import React, { useEffect, useState } from 'react';
import { Card, Row, Col, CardHeader, Label } from 'reactstrap';
import CustomSelect from '../../Components/Common/CustomSelect';
import CustomSelectWithSearch from '../../Components/Common/CustomSelectWithSearch';
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { createAnalytics, getMarketCampaignIds } from '../../slices/analytics/thunk';
import { setAnalyticsCampaigns, setAnalyticsPreloader, setChildTableData, setClick, setClickByDeviceData, setCreativesData, setEndDate, setImpression, setImpressionByDeviceData, setLocationData, setSelectedBrandId, setSelectedCampaignId, setSelectedClientId, setSelectedMarketId, setStartDate, setStatisticsChartData } from '../../slices/analytics/reducer';
import { setBrandPath, setClientPath, setMarketPath } from '../../slices/auth/menu/thunk';
import { setCampaignPath } from '../../slices/auth/menu/reducer';
import { useLocation, useParams } from 'react-router-dom';
import { push, replace } from 'redux-first-history';
import { setVersions } from '../../slices/analytics/reducer';
import { getTodayAndPastWeek } from '../../slices/analytics/helper';

function Search() {
  const dispatch = useDispatch();
  const location = useLocation();

  const selectStates = createSelector(state => state, state => ({
    company: state.MenuData.analyticsMenubar,
    clientPath: state.MenuData.clientPath,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    campaignPath: state.MenuData.campaignPath,
    selectedClientId: state.Analytics.selectedClientId,
    selectedBrandId: state.Analytics.selectedBrandId,
    selectedMarketId: state.Analytics.selectedMarketId,
    selectedCampaignId: state.Analytics.selectedCampaignId,
    analyticsCampaigns: state.Analytics.analyticsCampaigns,
    previousLocations: state.router.previousLocations,
    startDate: state.Analytics.startDate,
    endDate: state.Analytics.endDate
  }));
  const {
    company,
    clientPath,
    brandPath,
    marketPath,
    campaignPath,
    selectedClientId,
    selectedBrandId,
    selectedMarketId,
    selectedCampaignId,
    analyticsCampaigns,
    previousLocations,
    startDate,
    endDate
  } = useSelector(selectStates);
  // Option States
  const [clients, setClients] = useState([]);
  const [brands, setBrands] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [campaigns, setCampaigns] = useState([]);

  // Value States
  const [clientVal, setClientVal] = useState({});
  const [brandVal, setBrandVal] = useState({});
  const [marketVal, setMarketVal] = useState({});
  const [campaignVal, setCampaignVal] = useState({});

  useEffect(() => {
    if (company?.clients.length > 0) {
      setClients([
        { name: 'All', value: '1' },
        ...company?.clients.map(item => { return { name: item.clientName, value: item._id } })
      ]);
    }
  }, [company]);

  useEffect(() => {
    dispatch(setSelectedClientId(clientPath));
    dispatch(setSelectedBrandId(brandPath));
    dispatch(setSelectedMarketId(marketPath));
    dispatch(setSelectedCampaignId(campaignPath));
  }, [clientPath, brandPath, marketPath, campaignPath])

  useEffect(() => {
    if (selectedClientId) {
      const foundClient = company.clients.find(item => item._id === selectedClientId);
      if (foundClient) {
        setClientVal({ name: foundClient.clientName, value: foundClient._id });
        setBrands([
          { name: 'All', value: '1' },
          ...foundClient.brands.map(item => { return { name: item.name, value: item._id } })
        ]);
      } else if (selectedClientId === '1') {
        setClientVal({ name: 'All', value: '1' })
        setBrands([{ name: 'All', value: '1' }]);
      }
      setBrandVal({ name: 'All', value: '1' });
      setMarkets([{ name: 'All', value: '1' }]);
      setMarketVal({ name: 'All', value: '1' });
      setCampaigns([{ name: 'All', value: '1' }]);
      setCampaignVal({ name: 'All', value: '1' });
    }
  }, [selectedClientId]);

  useEffect(() => {
    if (selectedClientId && selectedClientId !== '1' && selectedBrandId) {
      const foundClient = company.clients.find(item => item._id === selectedClientId);
      const foundBrand = foundClient.brands.find(item => item._id === selectedBrandId);
      if (foundBrand) {
        setBrandVal({ name: foundBrand.name, value: foundBrand._id });
        setMarkets([
          { name: 'All', value: '1' },
          ...foundBrand.markets.map(item => { return { name: item.name, value: item._id } })
        ]);
      } else if (selectedBrandId === '1') {
        setMarkets([{ name: 'All', value: '1' }]);
      }
      setMarketVal({ name: 'All', value: '1' });
      setCampaigns([{ name: 'All', value: '1' }]);
      setCampaignVal({ name: 'All', value: '1' });
    } else {
      setBrandVal({ name: 'All', value: '1' });
      setBrands([{ name: 'All', value: '1' }]);
      setMarketVal({ name: 'All', value: '1' });
      setMarkets([{ name: 'All', value: '1' }]);
      setCampaigns([{ name: 'All', value: '1' }]);
      setCampaignVal({ name: 'All', value: '1' });
    }
  }, [selectedBrandId]);

  useEffect(() => {
    async function handleMarkets() {
      if (selectedClientId && selectedClientId !== '1' && selectedBrandId && selectedBrandId !== '1' && selectedMarketId) {
        const foundClient = company.clients.find(item => item._id === selectedClientId);
        const foundBrand = foundClient.brands.find(item => item._id === selectedBrandId);
        if (foundBrand) {
          const foundMarket = foundBrand.markets.find(item => item._id === selectedMarketId);
          if (foundMarket) {
            setMarketVal({ name: foundMarket.name, value: foundMarket.value });
            // dispatch(setAnalyticsPreloader(true));
            const marketCampaigns = await dispatch(getMarketCampaignIds());
            // dispatch(setAnalyticsPreloader(false));
            setCampaigns(Array.isArray(marketCampaigns.payload) ? marketCampaigns.payload.map(item => { return { name: item.name, value: item._id }}) : []);
            setCampaignVal({ name: 'All', value: '1' });
          } else if (selectedMarketId === '1') {
            setCampaigns([{ name: 'All', value: '1' }]);
            setCampaignVal({ name: 'All', value: '1' });
          }
        }
      } else {
        setMarketVal({ name: 'All', value: '1' });
        setMarkets([{ name: 'All', value: '1' }]);
        setCampaigns([{ name: 'All', value: '1' }]);
        setCampaignVal({ name: 'All', value: '1' });
      }
    }
    handleMarkets();
  }, [selectedMarketId]);

  useEffect(() => {
    async function getCampaign() {
      if (selectedCampaignId && campaigns) {
        const foundCampaign = campaigns.find(item => item.value === selectedCampaignId);
        if (foundCampaign) {
          setCampaignVal(foundCampaign);
        }
      } else {
        setCampaignVal({ name: 'All', value: '1' })
      }

    }
    getCampaign();
  }, [selectedCampaignId, campaigns]);

  useEffect(() => {
    if (previousLocations[0].location.state === null && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP")) {
      const today = new Date();
      const oneWeekAgo = new Date(today);
      oneWeekAgo.setDate(today.getDate() - 7);
      setTimeout(() => {
        searchData([oneWeekAgo, today], true);
      }, 1);
    } else if (previousLocations[0].location.state !== null) {
      dispatch(setAnalyticsCampaigns((previousLocations[0].location.state?.campaignsState)));
      dispatch(setImpression(previousLocations[0].location.state?.totalImpression));
      dispatch(setClick(previousLocations[0].location.state?.totalClick));
      dispatch(setChildTableData(previousLocations[0].location.state?.childTableState));
      dispatch(setImpressionByDeviceData(previousLocations[0].location.state?.impressionByDeviceState));
      dispatch(setClickByDeviceData(previousLocations[0].location.state?.clickByDeviceState));
      dispatch(setLocationData(previousLocations[0].location.state?.locationState));
      dispatch(setStatisticsChartData(previousLocations[0].location.state?.statisticsState));
      dispatch(setCreativesData(previousLocations[0].location.state?.creativeDataState));
      dispatch(setVersions(previousLocations[0].location.state?.versionsState));
    }
  }, [previousLocations]);

  async function searchData(dates = [], pushBool = true) {
    if (dates?.length === 2) {
      dispatch(setStartDate(dates[0].toISOString().split('T')[0]));
      dispatch(setEndDate(dates[1].toISOString().split('T')[0]));
      // dispatch(setAnalyticsPreloader(true));
      await dispatch(createAnalytics(pushBool));
      // dispatch(setAnalyticsPreloader(false));
    }
  }

  function changeClient(item) {
    dispatch(setSelectedClientId(item.value));
    dispatch(setSelectedBrandId('1'));
    dispatch(setSelectedMarketId('1'));
    dispatch(setSelectedCampaignId('1'));

  }

  function changeBrand(item) {
    dispatch(setSelectedBrandId(item.value));
    dispatch(setSelectedMarketId('1'));
    dispatch(setSelectedCampaignId('1'));
  }

  function changeMarket(item) {
    dispatch(setSelectedMarketId(item.value));
    dispatch(setSelectedCampaignId('1'));
  }

  function changeCampaign(item) {
    dispatch(setSelectedCampaignId(item.value));
  }
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <div className='w-100 d-flex justify-content-between align-items-center'>
            <div className='d-flex flex-wrap'>
              <div>
                <Label className='w-100' htmlFor='client'>Client</Label>
                <CustomSelectWithSearch
                  tag='button'
                  className='btn btn-light dropdown-toggle'
                  placeholder='Select Client'
                  id={'client'}
                  style={{ width: '160px' }}
                  options={clients}
                  onChange={(item) => { changeClient(item) }}
                  value={(clientVal?.name || '')}
                />
              </div>
              <div className='ms-2'>
                <Label className='w-100' htmlFor='brand'>Brand</Label>
                <CustomSelectWithSearch
                  tag='button'
                  className='btn btn-light dropdown-toggle'
                  placeholder='Select Brand'
                  id={'brand'}
                  style={{ width: '160px' }}
                  options={brands}
                  onChange={(item) => { changeBrand(item) }}
                  value={(brandVal?.name || '')}
                />
              </div>
              <div className='ms-2'>
                <Label className='w-100' htmlFor='market'>Market</Label>
                <CustomSelectWithSearch
                  tag='button'
                  className='btn btn-light dropdown-toggle'
                  placeholder='Select Market'
                  id={'market'}
                  style={{ width: '160px' }}
                  options={markets}
                  onChange={(item) => { changeMarket(item) }}
                  value={(marketVal?.name || '')}
                />
              </div>
              <div className='ms-2'>
                <Label className='w-100' htmlFor='campaign'>Campaign</Label>
                <CustomSelectWithSearch
                  tag='button'
                  className='btn btn-light dropdown-toggle'
                  placeholder='Select Campaign'
                  id={'campaign'}
                  style={{ width: '160px' }}
                  options={campaigns}
                  onChange={(item) => { changeCampaign(item) }}
                  value={(campaignVal?.name || '')}
                />
              </div>
            </div>
            <div>
              <div className='input-group flex-nowrap'>
                <Flatpickr
                  className="form-control border-0 dash-filter-picker shadow custom-date-picker"
                  options={{
                    onChange: (e) => {
                      searchData(e);
                    },
                    mode: "range",
                    dateFormat: "d M, Y",
                    maxDate: "today",
                    defaultDate: (() => {
                      let [startDate, endDate] = getTodayAndPastWeek();
                      startDate = startDate.toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                      });
                      endDate = endDate.toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                      });
                      return [startDate, endDate];
                    })()
                  }}
                />
                <div className="input-group-text bg-primary border-primary text-white calendar-icon">
                  <i className="ri-calendar-2-line"></i>
                </div>
              </div>
            </div>
          </div>
        </CardHeader>
      </Card>
    </React.Fragment>
  )
}

export default Search;